import { render, staticRenderFns } from "./CustomTooltip.vue?vue&type=template&id=36f828b3&scoped=true"
import script from "./CustomTooltip.vue?vue&type=script&lang=js"
export * from "./CustomTooltip.vue?vue&type=script&lang=js"
import style0 from "./CustomTooltip.vue?vue&type=style&index=0&id=36f828b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f828b3",
  null
  
)

export default component.exports